// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.List-module__dsAccented--kDUBw,.List-module__dsAccented--kDUBw *{font-weight:500}.List-module__dsDefaultWeight--YjLVh,.List-module__dsDefaultWeight--YjLVh *{font-weight:400}h5.List-module__dsAccented--kDUBw,h5.List-module__dsAccented--kDUBw *{font-weight:700}.List-module__dsUnderline--i7HU7,.List-module__dsUnderline--i7HU7 *{text-decoration:underline}.List-module__dsAccented2--ks_2T,.List-module__dsAccented2--ks_2T *{font-weight:700}.List-module__dsBodyXL--p0uO2,.List-module__dsBodyXL--p0uO2 *{font-size:18px;line-height:27px}.List-module__dsBodyLarge--wR0uK,.List-module__dsBodyLarge--wR0uK *{font-size:16px;line-height:24px}.List-module__dsBody--IFZbe,.List-module__dsBody--IFZbe *{font-size:14px;line-height:20px}.List-module__dsBodySmall--G4zq_,.List-module__dsBodySmall--G4zq_ *{font-size:12px;line-height:18px}.List-module__dsBodyXS--roTtf,.List-module__dsBodyXS--roTtf *{font-size:10px;line-height:15px}.List-module__dsActionLarge--UJhqq,.List-module__dsActionLarge--UJhqq *{font-size:16px;line-height:18px}.List-module__dsAction--zhYLl,.List-module__dsAction--zhYLl *{font-size:14px;line-height:16px}.List-module__dsActionSmall--CXB5V,.List-module__dsActionSmall--CXB5V *{font-size:12px;line-height:14px}.List-module__dsColumnHeadLine--AfdBB,.List-module__dsColumnHeadLine--AfdBB *{font-size:12px;line-height:18px;font-weight:500;text-transform:uppercase}.List-module__dsLightXL--ut69G,.List-module__dsLightXL--ut69G *{font-size:120px;line-height:160px;font-weight:300}.List-module__dsLightLarge--sunpm,.List-module__dsLightLarge--sunpm *{font-size:48px;line-height:64px;font-weight:300}.List-module__dsLight--VsaJv,.List-module__dsLight--VsaJv *{font-size:32px;line-height:64px;font-weight:300}.List-module__dsLightSmall--s614P,.List-module__dsLightSmall--s614P *{font-size:24px;line-height:36px;font-weight:300}.List-module__dsLightXS--ri1cD,.List-module__dsLightXS--ri1cD *{font-size:18px;line-height:27px;font-weight:300}.List-module__listContainer--VADFn{padding:0;margin:0}.List-module__listSearchField--ba1bs{border-bottom:1px solid #dce0ea}.List-module__listSearchField--ba1bs input{border-color:rgba(0,0,0,0)}.List-module__listSearchField--ba1bs input:hover:not(:disabled),.List-module__listSearchField--ba1bs input:focus:not(:disabled){border-color:rgba(0,0,0,0)}.List-module__listSearchField--ba1bs .List-module__searchIcon--HPOzf svg{color:#b3b9c8}.List-module__footerActionLinkBtn--fqU5v{height:40px;width:100%}.List-module__footerActionLinkBtn--fqU5v:hover{text-decoration:none}.List-module__listFooter--GuEMD{border-top:1px solid #dce0ea}.List-module__searchableListContainer--hwWV_{background:#fff;box-shadow:0px 0px 4px 0px rgba(0,0,0,.2509803922);border-radius:5px;overflow:hidden}.List-module__searchableListContainer--hwWV_:not(:has(.List-module__footerActionLinkBtn--fqU5v)) .List-module__searchableResultContainer--mwXsb{padding-bottom:6px}.List-module__searchableListContainer--hwWV_:not(:has(.List-module__listSearchField--ba1bs)) .List-module__searchableResultContainer--mwXsb{padding-top:6px}.List-module__searchableListContainerEmpty--FFF2J{padding:10px;text-align:center;font-size:12px;color:#191a1c;box-sizing:border-box}.List-module__searchableResultContainer--mwXsb{overflow-y:auto;max-height:var(--container-max-height);position:relative}.List-module__groupHeader--B2Yqh{display:flex;justify-content:space-between;align-items:center;padding-right:12px;padding-left:12px;padding-top:18px;background:#fff;position:relative;z-index:2}.List-module__groupHeader--B2Yqh.List-module__isSticky--mA06g{position:sticky;top:-1px}.List-module__groupHeader--B2Yqh.List-module__isExpandable--zKvMT{cursor:pointer}.List-module__groupHeader--B2Yqh:last-child:not(.List-module__groupIsExpanded--zCjg4){padding-bottom:8px}.List-module__groupHeader--B2Yqh:not(:first-child){border-top:1px solid #e2e2e2}.List-module__groupBody--ykSIP:last-child{padding-bottom:8px}.List-module__listGroupTitle--A9tHd{padding:18px 12px 4px 12px;color:var(--gray-5)}.List-module__groupHeaderTitle--wrYPx{display:flex;align-items:center;gap:4px}.List-module__groupHeaderTitle--wrYPx span{text-transform:uppercase;font-size:12px;font-weight:500;color:#8c95a8}.List-module__groupHeaderTitle--wrYPx svg{color:#8c95a8;width:12px;height:12px;display:block}.List-module__groupHeaderInfo--mNrHF{display:block;line-height:1;height:auto}.List-module__groupHeaderInfo--mNrHF:hover svg{color:#5155f5}.List-module__groupHeaderIcon--vjJlG{width:24px;height:24px;display:flex;align-items:center;justify-content:center;padding-right:8px}.List-module__groupHeaderIcon--vjJlG svg{color:#5f677e;display:block}.List-module__groupIsExpanded--zCjg4 .List-module__groupHeaderIcon--vjJlG svg{transform:rotate(180deg)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dsPrimaryBlue": `#5155f5`,
	"dsSecondaryBlue": `#e5e5fe`,
	"dsHoverBlue": `#3438d0`,
	"dsClickBlue": `#262ab5`,
	"dsClickBlue2": `#d3d4f0`,
	"dsClickBlue3": `#a8a9e1`,
	"dsClickBlue4": `#7c7fd2`,
	"dsClickBlue5": `#5154c3`,
	"dsBlack": `#191a1c`,
	"dsGray1": `#f5f7fa`,
	"dsGray2": `#eaecf2`,
	"dsGray3": `#dce0ea`,
	"dsGray4": `#b3b9c8`,
	"dsGray5": `#8c95a8`,
	"dsGray6": `#5f677e`,
	"dsGray7": `#3d4355`,
	"dsGrayMainHeader": `#373d4d`,
	"dsGrayLine": `#e2e2e2`,
	"dsGrayBackground": `#f4f4f5`,
	"dsWhite": `#fff`,
	"dsWarning": `#f14668`,
	"dsSuccess": `#00d41f`,
	"dsActionYellow": `#f3b32a`,
	"dsActionYellowLight": `#fef7e7`,
	"dsChartGreen": `#19a979`,
	"dsChartPink": `#ed4a7b`,
	"dsChartYellow": `#f4b400`,
	"dsChartPurple": `#945fcf`,
	"dsChartTurquoise": `#12a4b4`,
	"dsChartBlue": `#525df4`,
	"dsChartOrange": `#fb9341`,
	"dsChartBurgundy": `#bf399e`,
	"dsChartRed": `#ef6868`,
	"dsChartGrey": `#6c8893`,
	"dsChartDarkBlue": `#2e6497`,
	"dsChartOrangeLight": `#feddc3`,
	"dsChartLightBlue": `#5899da`,
	"dsTeamProRed": `#ff594c`,
	"dsFreeYellow": `#ffb42e`,
	"dsTeamsGreen": `#52aea4`,
	"dsTableRowHover": `#f7f8fa`,
	"dsTableNegativeHighlight": `#ffeae9`,
	"dsTableNegativeHighlightHover": `#ffe0df`,
	"dsSparklinePurple": `#777af7`,
	"dsPrimaryBlue100": `#f3f4fe`,
	"dsPrimaryBlue200": `#cfd0ff`,
	"dsPrimaryBlue300": `#8889f8`,
	"dsPrimaryBlue400": `#6c6ff7`,
	"dsPrimaryBlue500": `#575af5`,
	"dsPrimaryBlue600": `#4449f3`,
	"dsPrimaryBlue700": `#3339f1`,
	"dsPrimaryBlue800": `#1f29ef`,
	"dsPrimaryBlue900": `#1823de`,
	"dsPrimaryBlue1000": `#151fcc`,
	"dsMainHeader100": `#f9f9fa`,
	"dsMainHeader200": `#b5b7bc`,
	"dsMainHeader300": `#91959d`,
	"dsMainHeader400": `#7b7f89`,
	"dsMainHeader500": `#6b6f7b`,
	"dsMainHeader600": `#5e6370`,
	"dsMainHeader700": `#545967`,
	"dsMainHeader800": `#4b505f`,
	"dsMainHeader900": `#434958`,
	"dsMainHeader1000": `#3d4252`,
	"dsWarning100": `#fcdce3`,
	"dsWarning200": `#f9b5c2`,
	"dsWarning300": `#f46d88`,
	"dsWarning400": `#e44262`,
	"dsWarning500": `#c83a56`,
	"dsWarning600": `#b2344d`,
	"dsWarning700": `#a02f45`,
	"dsWarning800": `#922a3f`,
	"dsWarning900": `#852639`,
	"dsWarning1000": `#792334`,
	"dsH1FontSize": `32px`,
	"dsH1LineHeight": `48px`,
	"dsH2FontSize": `26px`,
	"dsH2LineHeight": `39px`,
	"dsH3FontSize": `22px`,
	"dsH3LineHeight": `33px`,
	"dsH4FontSize": `18px`,
	"dsH4LineHeight": `27px`,
	"dsH5FontSize": `16px`,
	"dsH5LineHeight": `24px`,
	"dsH6FontSize": `14px`,
	"dsH6LineHeight": `20px`,
	"dsBodyXLFontSize": `18px`,
	"dsBodyXLLineHeight": `27px`,
	"dsBodyLargeFontSize": `16px`,
	"dsBodyLargeLineHeight": `24px`,
	"dsBodyFontSize": `14px`,
	"dsBodyLineHeight": `20px`,
	"dsBodySmallFontSize": `12px`,
	"dsBodySmallLineHeight": `18px`,
	"dsBodyXSFontSize": `10px`,
	"dsBodyXSLineHeight": `15px`,
	"dsActionLargeSize": `16px`,
	"dsActionLargeLineHeight": `18px`,
	"dsActionSize": `14px`,
	"dsActionLineHeight": `16px`,
	"dsActionSmallSize": `12px`,
	"dsActionSmallLineHeight": `14px`,
	"dsColumnHeadFontSize": `12px`,
	"dsColumnHeadLineHeight": `18px`,
	"dsLightXLFontSize": `120px`,
	"dsLightXLLineHeight": `160px`,
	"dsLightLargeFontSize": `48px`,
	"dsLightLargeLineHeight": `64px`,
	"dsLightFontSize": `32px`,
	"dsLightLineHeight": `64px`,
	"dsLightSmallFontSize": `24px`,
	"dsLightSmallLineHeight": `36px`,
	"dsLightXSFontSize": `18px`,
	"dsLightXSLineHeight": `27px`,
	"dsXsIconSize": `12px`,
	"dsSmallIconSize": `14px`,
	"dsMediumIconSize": `16px`,
	"dsMediumFieldHeight": `36px`,
	"dsSmallFieldHeight": `32px`,
	"dsLargeFieldHeight": `40px`,
	"dsFieldHorizontalPadding": `12px`,
	"dsAccented": `List-module__dsAccented--kDUBw`,
	"dsDefaultWeight": `List-module__dsDefaultWeight--YjLVh`,
	"dsUnderline": `List-module__dsUnderline--i7HU7`,
	"dsAccented2": `List-module__dsAccented2--ks_2T`,
	"dsBodyXL": `List-module__dsBodyXL--p0uO2`,
	"dsBodyLarge": `List-module__dsBodyLarge--wR0uK`,
	"dsBody": `List-module__dsBody--IFZbe`,
	"dsBodySmall": `List-module__dsBodySmall--G4zq_`,
	"dsBodyXS": `List-module__dsBodyXS--roTtf`,
	"dsActionLarge": `List-module__dsActionLarge--UJhqq`,
	"dsAction": `List-module__dsAction--zhYLl`,
	"dsActionSmall": `List-module__dsActionSmall--CXB5V`,
	"dsColumnHeadLine": `List-module__dsColumnHeadLine--AfdBB`,
	"dsLightXL": `List-module__dsLightXL--ut69G`,
	"dsLightLarge": `List-module__dsLightLarge--sunpm`,
	"dsLight": `List-module__dsLight--VsaJv`,
	"dsLightSmall": `List-module__dsLightSmall--s614P`,
	"dsLightXS": `List-module__dsLightXS--ri1cD`,
	"listContainer": `List-module__listContainer--VADFn`,
	"listSearchField": `List-module__listSearchField--ba1bs`,
	"searchIcon": `List-module__searchIcon--HPOzf`,
	"footerActionLinkBtn": `List-module__footerActionLinkBtn--fqU5v`,
	"listFooter": `List-module__listFooter--GuEMD`,
	"searchableListContainer": `List-module__searchableListContainer--hwWV_`,
	"searchableResultContainer": `List-module__searchableResultContainer--mwXsb`,
	"searchableListContainerEmpty": `List-module__searchableListContainerEmpty--FFF2J`,
	"groupHeader": `List-module__groupHeader--B2Yqh`,
	"isSticky": `List-module__isSticky--mA06g`,
	"isExpandable": `List-module__isExpandable--zKvMT`,
	"groupIsExpanded": `List-module__groupIsExpanded--zCjg4`,
	"groupBody": `List-module__groupBody--ykSIP`,
	"listGroupTitle": `List-module__listGroupTitle--A9tHd`,
	"groupHeaderTitle": `List-module__groupHeaderTitle--wrYPx`,
	"groupHeaderInfo": `List-module__groupHeaderInfo--mNrHF`,
	"groupHeaderIcon": `List-module__groupHeaderIcon--vjJlG`
};
module.exports = ___CSS_LOADER_EXPORT___;
